exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabbar[data-v-2e0ed006]{position:absolute;bottom:-1px;left:0;width:100%}.taller[data-v-2e0ed006]{height:42px}@media screen and (min-width:767px){.hide-desktop[data-v-2e0ed006]{display:none}}", ""]);

// exports
